let settings = {
    development: {
        betradarApiUrl: 'http://btrd.api-core.com/api',
        // betradarApiUrl: 'http://localhost:52478/api',
        //betradarApiUrl: 'http://btrd-sierra.api-core.com/api',

        //sportsApiUrl: 'http://localhost:44307/api',
        //sportsApiUrl: 'http://51.68.181.111:64307/api',
        // sportsApiUrl: 'http://51.68.181.111:44307/api',
        //sportsApiUrl: 'https://sbet.oddin-platform.com/sportsofferapi/api',
        //sportsApiUrl: 'https://tbet.oddin-platform.com/sportsofferapi/api',
        sportsApiUrl: 'https://sapi.betplayworld.com/api',
        //sportsApiUrl: 'https://lgames.ibetplatform.com/sportsofferapi/api',

        //boApiUrl: 'http://localhost:61962/api',
        boApiUrl: 'https://boapi.betplayworld.com/api',
        //boApiUrl: 'https://sbet.oddin-platform.com/backofficeapi/api',
        //boApiUrl: 'https://tbet.oddin-platform.com/backofficeapi/api',
        //boApiUrl: 'http://51.68.181.111:55600/api', //qa
        //boApiUrl: 'http://51.68.181.111:55601/api', //qa ultima
        //boApiUrl: 'https://slboapi.api-core.com/api',
        //boApiUrl: 'https://lgames.ibetplatform.com/backofficeapi/api',

        //lottoApiUrl: 'http://localhost:51728/api',
        //lottoApiUrl: 'http://51.68.181.111:44359/api',
        //lottoApiUrl: 'https://sllotto.api-core.com/api',
        //lottoApiUrl: 'https://lgames.ibetplatform.com/lottoapi/api',
        lottoApiUrl: 'https://lapi.betplayworld.com/api',

        //printTemplates: 'https://localhost:44357',
        printTemplates: 'http://51.68.181.111:44357',

        //everymatrixApiUrl: 'http://localhost:44334/api',
        everymatrixApiUrl: 'http://em.api-core.com/api',
        //lsportsApiUrl:'http://51.68.181.111:10009/api'
        lsportsClientApiUrl: 'http://localhost:10009/api',
        lsportsProviderApiUrl: 'http://51.68.181.111:53998/api',
        //terminalApi: 'http://51.68.181.111:57496/api',
        //terminalApi: 'http://lgames-stage.api-core.com/terminalapi/api',
        terminalApi: 'https://betplayworld.com/terminalapi/api',
    },
    production: {
        betradarApiUrl: 'http://btrd.api-core.com/api',
        sportsApiUrl: 'https://sapi.betplayworld.com/api',
        boApiUrl: 'https://boapi.betplayworld.com/api',
        lottoApiUrl: 'https://lapi.betplayworld.com/api',
        printTemplates: 'http://51.68.181.111:44357',
        everymatrixApiUrl: 'http://em.api-core.com/api',
        lsportsClientApiUrl: 'http://51.68.181.111:10009/api',
        lsportsProviderApiUrl: 'https://lgames.ibetplatform.com/lsportsapi/api',
        terminalApi: 'https://betplayworld.com/terminalapi/api',
    },
};

export default settings;
